import React, { useEffect } from "react";
import Alert from "@material-ui/lab/Alert";

const AlertMessage = ({ message, setMessage }) => {
  useEffect(() => {
    if (message.active) {
      const timer = setTimeout(() => {
        closeAlert();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [message]);
  const closeAlert = () => {
    setMessage({
      type: null,
      text: "",
      active: false,
    });
  };
  const { type, active, text } = message;
  if (!active) return null;
  return (
    <Alert
      severity={type}
      onClose={closeAlert}
      duration={10000}
      variant="filled"
      style={{
        position: "fixed",
        top: 20,
        right: 20,
        minWidth: "30%",
        zIndex: 1000,
      }}
    >
      {text}
    </Alert>
  );
};

export default AlertMessage;
